import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';


export const searchInvoiceBookingNew = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/invoice-booking-pi-wise/searchInvoiceBookingNew`, data);
        return await response.data;
    } catch (error) {
        console.log("searchInvoiceBookingNew - error", error)
        return handleApiError(error)
    }
}

export const searchInvoiceBookingRaw = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/invoice-booking-pi-wise/searchInvoiceBookingRaw`, data);
        return await response.data;
    } catch (error) {
        console.log("searchInvoiceBookingRaw - error", error)
        return handleApiError(error)
    }
}

export const updatePurchaseInVoiceBookingStatus = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/invoice-booking-pi-wise/updatePIBookingStatus`, data);
        return await response.data;
    } catch (error) {
        console.log("updatePurchaseInVoiceBookingStatus - error", error)
        return handleApiError(error)
    }
}

export const getPurchaseInVoiceBookingTicketFollowers = async (body) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/invoice-booking-pi-wise/ticketFollowers`, body);
        return await response.data;
    } catch (error) {
        console.log("getPurchaseInVoiceBookingTicketFollowers - error", error)
        return handleApiError(error)
    }
}

export const getDuplicateSellerPIPunches = async (body) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/invoice-booking-pi-wise/pi-duplicate-check`, body);
        return await response.data;
    } catch (error) {
        console.log("getDuplicateSellerPIPunches - error", error)
        return handleApiError(error)
    }
}

export const getPIInvoiceBookingAlerts = async (body) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/invoice-booking-pi-wise/alerts`, body);
        return await response.data;
    } catch (error) {
        console.log("getPIInvoiceBookingAlerts - error", error)
        return handleApiError(error)
    }
}

export const getPIInvoicesBookingStatus = async (body) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/invoice-booking-pi-wise/booking-status`, body);
        return await response.data;
    } catch (error) {
        console.log("getPIInvoicesBookingStatus - error", error)
        return handleApiError(error)
    }
}